import { render, staticRenderFns } from "./RescuerPopup.vue?vue&type=template&id=6bc6106e"
import script from "./RescuerPopup.vue?vue&type=script&lang=js"
export * from "./RescuerPopup.vue?vue&type=script&lang=js"
import style0 from "./RescuerPopup.vue?vue&type=style&index=0&id=6bc6106e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports